import React from 'react';

import {pluralize} from 'BenchlingUtil';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import DeleteIcon from 'ui-library/icons/DeleteIcon';
import {immutableRemoveAt, immutableReplace} from 'util/ImmutableListUtil';
import {JSONArray} from 'util/Types';

import {StepConfigUISchema} from '../StepConfigEditorTypes';
import StepConfigEditorRouter from './StepConfigEditorRouter';

interface ArrayEditorProps {
  config: JSONArray;
  configShape: GetPipelineConfigSpecType<'array'>;
  dataTestAttrs: Pick<DataTestAttrs, 'key'>;
  onChangeConfig: (config: JSONArray) => void;
  uiSchema: StepConfigUISchema;
  disabled?: boolean;
}

export default function ArrayEditor({
  config,
  configShape,
  dataTestAttrs,
  onChangeConfig,
  uiSchema,
  disabled,
}: ArrayEditorProps): JSX.Element {
  const configArray = config ?? [];
  const isDeleteDisabled = configArray.length <= (configShape.minItems ?? 0);
  return (
    <>
      {configArray.map((element, index) => (
        <StepConfigEditorRouter
          key={index}
          config={element}
          configShape={configShape.elementSpec}
          dataTestAttrs={{key: dataTestAttrs.key, index: `${index}`}}
          disabled={disabled}
          uiSchema={uiSchema}
          onChangeConfig={(newValue) => {
            onChangeConfig(immutableReplace(configArray, index, newValue));
          }}
          trashIcon={
            disabled ? undefined : (
              <Tooltip
                isDisabled={!isDeleteDisabled}
                text={`Must have at least ${configShape.minItems ?? 0} ${pluralize(
                  configShape.minItems ?? 0,
                  'item',
                  'items'
                )}`}
              >
                <DeleteIcon
                  icon="trash-can"
                  disabled={isDeleteDisabled}
                  onClick={() => {
                    onChangeConfig(immutableRemoveAt(configArray, index));
                  }}
                />
              </Tooltip>
            )
          }
        />
      ))}
    </>
  );
}
